var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3Fountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.74 19.65a1.998 1.998 0 01-2.74-.79 8.55 8.55 0 00-7.49-4.44C43.11 14.42 40 19.36 40 28v24h-4V28c0-14.27 7.12-17.54 12.54-17.54a12.54 12.54 0 0111 6.51 2 2 0 01-.8 2.68zM51 35.22c-2.41 0-8 1.17-8 12V52h4v-4.78c0-3.65.69-8 4-8a4.001 4.001 0 013 1.35 2.002 2.002 0 003-2.65 8 8 0 00-6-2.7zm-28.3-3c4.45-.52 6.3 2.49 6.3 5.61V52h4V37.81a9.79 9.79 0 00-9.66-9.66 8.18 8.18 0 00-5.21 1.52 2.05 2.05 0 00-.93 2.25A2 2 0 0020.29 33a5.13 5.13 0 012.41-.8v.02zM19 57.27C19 65.61 31.63 66 35.92 66h4.16C44.37 66 57 65.61 57 57.27V56H19v1.27z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Fountain.391fb032.svg";
export { SvgB3Fountain as ReactComponent };